import axios from "src/lib/axios";

export const getAllSuggestComments = () => axios.get("/comments/all-comment");
